export default __webpack_public_path__ + "static/media/Animals-03.c4343b0b.png";